






































































































































































































import Vue from 'vue'
// @ts-ignore
import { AgGridVue } from 'ag-grid-vue'
import { hexToRgba } from '@/services/hex-to-rgba'
import { GridOptions } from '@/types'
import { ShiftBreak } from '@/model/master-data/ShiftBreak'
import AddressRequirementsBreakDialog from '@/components/master-data/address/AddressRequirementsBreakDialog.vue'
import { ShiftBreakPayload } from '@/types/payload'
import _ from 'lodash'
import DeleteDialog from '@/components/DeleteDialog.vue'
import { FreeShiftPlanningGroup } from '@/model/master-data/FreeShiftPlanningGroup'
import CommentCellRenderer from '@/components/cell-renderer/CommentCellRenderer.vue'
import { TranslateResult } from 'vue-i18n'
import moment from 'moment'
import { GET_SELECTED_UI_LANGUAGE } from '@/store/getter-types'
import { Department } from '@/model/companyStructure/Department'
import AddressRequirementsPlanningGroupDialog
  from '@/components/master-data/address/AddressRequirementsPlanningGroupDialog.vue'
import { PlanningGroup } from '@/model/companyStructure/PlanningGroup'
import AddressRequirementsAgreementDialog from '@/components/master-data/address/AddressRequirementsAgreementDialog.vue'
import QualityCellRenderer from '@/components/cell-renderer/QualityCellRenderer.vue'

interface DayListItem {
  id: number
  day: TranslateResult
}

interface ComponentData {
  formData: any
  startValidationRules: Array<Function>
  endValidationRules: Array<Function>
  departmentValidationRules: Array<Function>
  overlayNoRowsTemplate: string
  breakGridOptions: GridOptions
  selectedBreakData: ShiftBreak | undefined
  currentSelectedBreakId: string | undefined
  showBreakDialog: boolean
  breakDialogTitle: string
  showDeleteBreakDialog: boolean

  weekDayList: Array<DayListItem>

  selectedDepartmentId: number

  selectedAddedPlanningGroup: any,
  currentSelectedPlanningGroupId: string
  planningGroupGridOptions: GridOptions
  gridFrameworkComponents: Object
  showPlanningGroupDialog: boolean
  showDeletePlanningGroupDialog: boolean
  planningGroupDialogTitle: string

  showAgreementDialog: boolean
  agreementTitle: string
  selectedAgreementData: any
  agreementOptions: GridOptions
  showDeleteAgreementDialog: boolean
}

export default Vue.extend({
  name: 'AddressPlanningSpecifications',

  components: {
    AgGridVue,
    AddressRequirementsBreakDialog,
    AddressRequirementsPlanningGroupDialog,
    AddressRequirementsAgreementDialog,
    DeleteDialog
  },

  props: {
    show: {
      type: Boolean,
      default: false
    },
    title: String,
    dialogData: {
      type: Object as () => any
    },
    departmentList: {
      type: Array as () => Array<Department>
    },
    allPlanningGroupList: {
      type: Array as () => Array<PlanningGroup>
    },
  },

  data (): ComponentData {
    const required = (value: any): boolean | string => !!value || this.$t('masterData.shifts.required').toString()

    return {
      formData: {
        start: '', end: '', isActive: false, shiftBreakList: [], isUnique: false, selectedWeekDayList: [],
        expireAfterRepetitions: '', expireAfterDateIso: '', repeatEveryNthWeek: 1,
        planningGroupData: [], agreementData: [],
      },
      startValidationRules: [
        required
      ],
      endValidationRules: [
        required
      ],
      departmentValidationRules: [
        required
      ],
      overlayNoRowsTemplate: "<span>"+this.$t('errors.noRowsToShow')+"</span>",
      breakGridOptions: {
        columnDefs: [
          { headerName: this.$t('masterData.shifts.start'), field: 'startBreak', width: 100 },
          { headerName: this.$t('masterData.shifts.end'), field: 'endBreak', width: 100 },
          { headerName: this.$t('masterData.shifts.duration'), field: 'duration', width: 100 },
          { headerName: this.$t('masterData.shifts.capacityDeduction'), field: 'deductionCapacity'},
          { headerName: this.$t('masterData.shifts.comment'), field: 'comment', cellRenderer: 'commentCellRenderer', width: 535 },
        ]
      },
      selectedBreakData: undefined,
      currentSelectedBreakId: undefined,
      showBreakDialog: false,
      breakDialogTitle: '',
      showDeleteBreakDialog: false,

      weekDayList: [
        {day: this.$t('planningPage.monday'), id: 1},
        { day: this.$t('planningPage.tuesday'), id: 2},
        { day: this.$t('planningPage.wednesday'), id: 3},
        { day: this.$t('planningPage.thursday'), id: 4},
        { day: this.$t('planningPage.friday'), id: 5},
        { day: this.$t('planningPage.saturday'), id: 6},
        { day: this.$t('planningPage.sunday'), id: 7},
      ],

      selectedDepartmentId: 0,

      selectedAddedPlanningGroup: undefined,
      currentSelectedPlanningGroupId: '',
      planningGroupGridOptions: {
        columnDefs: [
          { headerName: this.$t('masterData.shifts.planningGroup'), field: 'planningGroupName' },
          { headerName: this.$t('masterData.shifts.numberOfEmployees'), field: 'numberOfEmployees' },
          { headerName: this.$t('masterData.shifts.offset'), field: 'offset', width: 100 },
          { headerName: this.$t('masterData.shifts.comment'), field: 'comment', width: 230, cellRenderer: 'commentCellRenderer' },
        ]
      },

      gridFrameworkComponents: {
        commentCellRenderer: CommentCellRenderer,
        qualityCellRenderer: QualityCellRenderer
      },
      showPlanningGroupDialog: false,
      showDeletePlanningGroupDialog: false,
      planningGroupDialogTitle: '',

      showAgreementDialog: false,
      agreementTitle: '',
      selectedAgreementData: undefined,
      agreementOptions: {
        columnDefs: [
          { headerName: this.$t('employeeFormComponent.qcq.competence'), field: 'description'},
          { headerName: 'Qualität', field: 'quality', width: 535, cellRenderer: 'qualityCellRenderer'}
        ]
      },
      showDeleteAgreementDialog: false
    }
  },

  watch: {
    show (newVal: boolean): void {
      if(newVal) {
        this.formData = {
          start: '', end: '', isActive: false, shiftBreakList: [], isUnique: false, selectedWeekDayList: [],
              expireAfterRepetitions: '', expireAfterDateIso: '', repeatEveryNthWeek: 1,
              planningGroupData: [], agreementData: [],
        }
      }
    }
  },

  computed: {
    expireAfterDateFormatted: {
      get (): string | undefined {
        if (this.formData.expireAfterDateIso) {
          return moment(this.formData.expireAfterDateIso).format('DD.MM.YYYY')
        }
        return undefined
      },
      // setter is only for clear action to work
      set (): void {
        this.formData.expireAfterDateIso = ''
      }
    },

    selectedLocale(): string {
      return this.$store.getters[GET_SELECTED_UI_LANGUAGE].code
    },

    toolbarColor (): string {
      return hexToRgba(this.$vuetify.theme.themes.light.primary)
    },

    isEnableBreakButtons (): boolean {
      return !!this.currentSelectedBreakId
    },

    isEnableButtons (): boolean {
      return !!this.currentSelectedPlanningGroupId
    },

    isEnableAgreementButtons (): boolean {
      return !!this.selectedAgreementData
    },

    breakList (): Array<ShiftBreak> | undefined {
      if (this.formData) {
        return this.formData.shiftBreakList
      } else {
        return undefined
      }
    },

    isEnabled (): boolean {
      return this.formData.isUnique
    },

    planningGroupList (): Array<FreeShiftPlanningGroup> | undefined {
      if (this.formData) {
        return this.formData.planningGroupData
      } else {
        return undefined
      }
    },

    filteredPlanningGroupList (): Array<PlanningGroup> {
      return this.allPlanningGroupList
    },
  },

  methods: {
    onBreakRowClicked (params: any): void {
      this.currentSelectedBreakId = params.node.data.id
      this.selectedBreakData = params.data
    },

    onAddBreakClick (): void {
      this.currentSelectedBreakId = undefined
      this.selectedBreakData = undefined
      this.breakDialogTitle = this.$t('masterData.shifts.addBreak').toString()
      this.showBreakDialog = true
    },

    onEditBreakClick (): void {
      this.breakDialogTitle = this.$t('masterData.shifts.editBreak').toString()
      this.showBreakDialog = true
    },

    onCreateNewBreak (data: ShiftBreakPayload): void {
      let maxId: ShiftBreak | undefined = _.maxBy(this.breakList, 'id')
      if(this.formData) {
        this.formData.shiftBreakList.push(
          ShiftBreak.create(
            maxId ? maxId.id + 1 : 1,
            this.formData.id ? this.formData.id.toString() : '',
            data.startBreak,
            data.endBreak,
            data.duration,
            data.deductionCapacity,
            data.comment)
        )
      }
      this.currentSelectedBreakId = undefined
      this.selectedBreakData = undefined
      this.showBreakDialog = false
    },

    onEditBreak (data: ShiftBreakPayload): void {
      if(this.formData && this.formData.shiftBreakList && this.selectedBreakData && this.currentSelectedBreakId) {
        let index: number = this.formData.shiftBreakList.indexOf(this.selectedBreakData)
        this.formData.shiftBreakList.splice(index, 1, ShiftBreak.create(
          parseInt(this.currentSelectedBreakId),
          this.formData.id ? this.formData.id.toString() : '',
          data.startBreak,
          data.endBreak,
          data.duration,
          data.deductionCapacity,
          data.comment)
        )
      }
      this.currentSelectedBreakId = undefined
      this.selectedBreakData = undefined
      this.showBreakDialog = false
    },

    onBreakDialogClose (): void {
      this.showBreakDialog = false
      this.currentSelectedBreakId = undefined
      this.selectedBreakData = undefined
    },

    onDeleteBreakClick (): void {
      this.showDeleteBreakDialog = true
    },

    deleteBreak (): void {
      if(this.formData && this.formData.shiftBreakList && this.selectedBreakData) {
        let index: number = this.formData.shiftBreakList.indexOf(this.selectedBreakData)
        this.formData.shiftBreakList.splice(index, 1)
      }
      this.currentSelectedBreakId = undefined
      this.selectedBreakData = undefined
      this.showDeleteBreakDialog = false
    },

    onDeleteBreakDialogClose (): void {
      this.showDeleteBreakDialog = false
    },

    onAddPlanningGroupClick (): void {
      this.selectedAddedPlanningGroup = undefined
      this.currentSelectedPlanningGroupId= ''
      this.planningGroupDialogTitle = this.$t('masterData.shifts.addNewFreeShiftPlanningGroup').toString()
      this.showPlanningGroupDialog = true
    },

    onEditPlanningGroupClick (): void {
      this.planningGroupDialogTitle = this.$t('masterData.shifts.editFreeShiftPlanningGroup').toString()
      this.showPlanningGroupDialog = true
    },

    onPlanningGroupRowClicked (params: any): void {
      this.currentSelectedPlanningGroupId = params.node.data.planningGroup
      this.selectedAddedPlanningGroup = params.data
    },

    onPlanningGroupDialogClose (): void {
      this.showPlanningGroupDialog = false
    },

    onSavePlanningGroup (item: any): void {
      if(item.id) {
        const idx: number = this.formData.planningGroupData.indexOf(this.selectedAddedPlanningGroup)
        this.formData.planningGroupData.splice(idx, 1, item)
        this.selectedAddedPlanningGroup = undefined
        this.currentSelectedPlanningGroupId= ''
        this.showPlanningGroupDialog = false
      } else {
        const maxId: any = _.maxBy(this.formData.planningGroupData, 'id')
        item.id = maxId ? maxId.id + 1 : 1,
        this.formData.planningGroupData.push(item)
        this.selectedAddedPlanningGroup = undefined
        this.currentSelectedPlanningGroupId= ''
        this.showPlanningGroupDialog = false
      }
    },


    onDeletePlanningGroupClick (): void {
      this.showDeletePlanningGroupDialog = true
    },

    deletePlanningGroup () {
      const idx: number = this.formData.planningGroupData.indexOf(this.selectedAddedPlanningGroup)
      this.formData.planningGroupData.splice(idx, 1)
      this.selectedAddedPlanningGroup = undefined
      this.currentSelectedPlanningGroupId= ''
      this.showDeletePlanningGroupDialog = false
    },

    onDeletePlanningGroupDialogClose (): void {
      this.showDeletePlanningGroupDialog = false
    },

    onAddAgreementClick (): void {
      this.selectedAgreementData = undefined
      this.agreementTitle = 'Vereinbarung hinzufügen'
      this.showAgreementDialog = true
    },

    onAgreementRowClicked (params: any): void {
      this.selectedAgreementData = params.data
    },

    onEditAgreementClick (): void {
      this.agreementTitle = 'Vereinbarung bearbeiten'
      this.showAgreementDialog = true
    },

    onAgreementDialogSave (item: any): void {
      if(item.id) {
        const idx: number = this.formData.agreementData.indexOf(this.selectedAgreementData)
        this.formData.agreementData.splice(idx, 1, item)
        this.selectedAgreementData = undefined
        this.showAgreementDialog = false
      } else {
        const maxId: any = _.maxBy(this.formData.agreementData, 'id')
        item.id = maxId ? maxId.id + 1 : 1,
        this.formData.agreementData.push(item)
        this.selectedAgreementData = undefined
        this.showAgreementDialog = false
      }
    },

    onAgreementDialogClose (): void {
      this.showAgreementDialog = false
    },

    onDeleteAgreementClick (): void {
      this.showDeleteAgreementDialog = true
    },

    onDeleteAgreementDialogClose (): void {
      this.showDeleteAgreementDialog = false
    },

    deleteAgreement (): void {
      const idx: number = this.formData.agreementData.indexOf(this.selectedAgreementData)
      this.formData.agreementData.splice(idx, 1)
      this.selectedAgreementData = undefined
      this.showDeleteAgreementDialog = false
    },

    onSaveButtonClick (): void {
     this.$emit('save', this.formData)
    },

    onCloseButtonClick (): void {
      this.$emit('close')
    }
  }

})
